import { userRequests } from './entityRequests/userRequests';
import { reportRequests } from './entityRequests/reportRequests';
import { commonRequests } from './entityRequests/commonRequests';
import { sentimentAnalysisRequests } from './entityRequests/sentimentAnalysisRequests';
import { keywordsStatsRequests } from './entityRequests/keywordsStatsRequests';
import { callStatsRequests } from './entityRequests/callStatsRequests';
import { gamificationRequests } from './entityRequests/gamificationRequests';
import { liveAgentsRequests } from './entityRequests/liveAgentsRequests';
import { callDurationStatsRequests } from './entityRequests/callDurationStatsRequests';
import { callAmountStatsRequests } from './entityRequests/callAmountStatsRequests';
import { dataPrivacyRequests } from './entityRequests/dataPrivacyConfigRequest';
import { type RequestHandlerFactory } from '../types';

export const REQUESTS: Record<string, RequestHandlerFactory> = {
    ...userRequests,
    ...keywordsStatsRequests,
    ...callStatsRequests,
    ...commonRequests,
    ...reportRequests,
    ...gamificationRequests,
    ...liveAgentsRequests,
    ...callDurationStatsRequests,
    ...callAmountStatsRequests,
    ...dataPrivacyRequests,
    ...sentimentAnalysisRequests
};
